/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";

import {
  ModalFooter,
  ModalBody,
  ModalHeader,
  Modal,
  Row,
  Col,
  Spinner,
  Label,
  FormGroup,
  UncontrolledTooltip,
} from "reactstrap";

import {
  changeDisplayName,
  resetChangeDisplayNameStatus,
} from "../../../../store/changeDisplayName/actions";

import { withTranslation } from "react-i18next";

import toastr from "toastr";
import "toastr/build/toastr.min.css";

import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import schema from "./ChangeDisplayNameValidation.js";

const ChangeDisplayName = ({
  t,
  conversationId,
  chatDisplayName,
  chatName,
  toggle,
  isOpen,
  onSubmit,
}) => {
  const dispatch = useDispatch();

  const { status } = useSelector((state) => state.ChangeDisplayName);

  const { register, handleSubmit, setValue, errors } = useForm({
    resolver: yupResolver(schema),
  });

  const [displayName, setDisplayName] = useState(null);
  const [newPayload, setNewPayload] = useState({
    chatId: null,
    display_name: null,
  });

  const handleChangeDisplayName = () => {
    dispatch(changeDisplayName(newPayload?.chatId, newPayload?.display_name));
  };

  const setClassName = (errors, classname) => {
    return errors ? "av-invalid is-invalid " + classname : classname;
  };

  const showToast = (type, message) => {
    toastr.options = {
      closeButton: false,
      debug: false,
      newestOnTop: false,
      progressBar: true,
      positionClass: "toast-top-right",
      preventDuplicates: true,
      onclick: null,
      showDuration: "200",
      hideDuration: "200",
      timeOut: "2000",
      extendedTimeOut: "2000",
      showEasing: "swing",
      hideEasing: "linear",
      showMethod: "fadeIn",
      hideMethod: "fadeOut",
      onHidden: () => {
        toggle();
        dispatch(resetChangeDisplayNameStatus("change_display_name"));
      },
    };
    toastr[type](message);
  };

  useEffect(() => {
    if (status?.change_display_name?.error) {
      showToast("error", t(status.change_display_name.error?.message));
      onSubmit(status?.change_display_name);
    }
    if (status?.change_display_name?.success) {
      showToast("success", t("Change contact name success"));
      onSubmit(status?.change_display_name);
    }
  }, [status]);

  useEffect(() => {
    chatDisplayName && setDisplayName(chatDisplayName);
  }, [chatDisplayName]);

  useEffect(() => {
    chatDisplayName && setNewPayload({ ...newPayload, chatId: conversationId });
  }, [conversationId]);

  return (
    <>
      <div>
        <i
          id="tooltip-edit-name"
          className="mdi mdi-pencil font-size-12 pl-2 pr-1"
        />
        <UncontrolledTooltip placement="top" target="tooltip-edit-name">
          {t("Edit name")}
        </UncontrolledTooltip>
      </div>
      <Modal isOpen={isOpen} toggle={toggle}>
        <form onSubmit={handleSubmit(handleChangeDisplayName)}>
          <ModalHeader
            className="modal-header-no-button px-4 pt-4"
            toggle={toggle}
          >
            {t("Edit name")}
          </ModalHeader>
          <ModalBody className="px-4">
            <Row>
              <Col>
                <FormGroup>
                  <Label id="displayName-label">{t("Contact name")}</Label>
                  <div className="d-flex">
                    <input
                      type="text"
                      name="displayName"
                      autoComplete="off"
                      ref={register}
                      className={setClassName(
                        errors.displayName,
                        "lline form-control"
                      )}
                      placeholder={t("Enter contact name")}
                      onChange={(e) => {
                        const value = e?.target?.value ?? "";
                        setDisplayName(value);
                        setNewPayload({ ...newPayload, display_name: value });
                      }}
                      defaultValue={displayName}
                    />
                    <div id="delete-displayname" className="align-self-center">
                      <i
                        className=" mdi mdi-window-close text-danger font-size-18 pl-2 pointer"
                        onClick={() => {
                          setValue("displayName", chatName, {
                            shouldValidate: true,
                          });
                          setDisplayName(chatName);
                          setNewPayload({ ...newPayload, display_name: null });
                        }}
                      />
                    </div>

                    <UncontrolledTooltip
                      placement="top"
                      target="delete-displayname"
                    >
                      {t("Return to the default name")}
                    </UncontrolledTooltip>
                  </div>
                  <div className="invalid-feedback d-block">
                    {t(errors?.displayName?.message)}
                  </div>
                </FormGroup>
              </Col>
            </Row>
          </ModalBody>
          <ModalFooter className="px-4 pb-4">
            <button
              type="button"
              onClick={toggle}
              className="btn waves-effect waves-light btn-dark"
              data-dismiss="modal"
            >
              {t("Cancel")}
            </button>

            {status?.change_display_name?.loading ? (
              <button
                type="button"
                color="primary"
                className="btn btn-primary waves-effect waves-light"
              >
                <Spinner size="sm" animation="border" />
              </button>
            ) : (
              <button
                type="submit"
                color="primary"
                className="btn btn-primary"
                disabled={
                  errors?.displayName ||
                  chatDisplayName === displayName ||
                  newPayload?.display_name === ""
                }
              >
                {t("Confirm")}
              </button>
            )}
          </ModalFooter>
        </form>
      </Modal>
    </>
  );
};

export default withTranslation()(ChangeDisplayName);
